import { useEsigningSettings } from 'app/domains/esigning/hooks/useEsigningSettings';
import { OrderedSigningRecipients } from './OrderedSigningRecipients';
import { UnorderedSigningRecipients } from './UnorderedSigningRecipients';
export function Signers() {
    const { requireOrder } = useEsigningSettings();
    if (requireOrder) {
        return <OrderedSigningRecipients />;
    }
    return <UnorderedSigningRecipients />;
}
